<template>
    <ContentOrLoading>
        <ValidationObserver ref="observer" v-if="!loading">
            <section class="padding-vertical-content lightgray-content pt-0 mb-3 mb-lg-4" id="paso-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12 mb-4 h4 text-uppercase pt-4">
                            {{ $t('bases.indumentarias_disponibles') }}
                        </div>
                        <template v-for="(indumentaria, index) in indumentarias">
                            <div class="col-12 col-md-6 col-xl-4 text-center mb-3 p-2" :key="indumentaria.id">
                                <div class="card mx-auto" style="width: 20rem;">
                                    <div class="mx-auto mt-2">
                                        <img class="card-img-top" :src="indumentaria.imagen" alt="" style="height: 180px; max-height: 190px; max-width: 240px;"/>
                                    </div>
                                    <div style="color: #013765">
                                        <h4>{{ indumentaria.nombre }}</h4>
                                        <div v-if="indumentaria.incluida">
                                            <h4 class="m-0"><del>{{ indumentaria.precio | formatear_precio }}</del> <h3 class="d-inline ml-1">(0 €)</h3></h4>
                                            <small>{{ $t('bases.max_incluidas') }} {{ indumentaria.cantidad_incluida }}</small>
                                        </div>
                                        <h3 v-else>{{ indumentaria.precio | formatear_precio }}</h3>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <ValidationProvider name="talla" :id="'talla-' + index">
                                            <multiselect 
                                                v-model="indumentaria.tallaSelect"
                                                :disabled="!paso_activo"
                                                :id="'talla-' + index"
                                                placeholder="Talla"
                                                class="mr-1"
                                                style="width: 5.5rem;"
                                                label="nombre"
                                                track-by="id"
                                                :options="indumentaria.tallasSelect"
                                                :show-labels="false"
                                            >
                                                <template slot="noOptions">{{ $t('bases.no_tallas') }}</template>
                                            </multiselect>
                                        </ValidationProvider>
                                        <ValidationProvider v-if="indumentaria.tallaSelect" name="stock" :id="'stock-' + index">
                                            <multiselect 
                                                v-model="indumentaria.stockSelect"
                                                :disabled="!indumentaria.tallaSelect || !paso_activo"
                                                :id="'stock-' + index"
                                                placeholder="Ud"
                                                style="width: 4.7rem;"
                                                :options="indumentaria.tallaSelect.stockArray"
                                                :show-labels="false"
                                            >
                                                <template slot="noOptions">{{ $t('bases.no_unidades') }}</template>
                                            </multiselect>
                                        </ValidationProvider>
                                    </div>
                                    <button :disabled="!indumentaria.tallaSelect || !indumentaria.stockSelect" type="button" :id="'add-indumentaria-' + index" class="btn p-1 m-1" style="font-size: 12px;" @click="addIndumentaria(indumentaria)">{{ $t('bases.anadir_indumentaria') }}</button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="text-center">
                    <hr width="69%"/>
                    <h4>{{ $t('bases.indumentarias_elegidas') }}</h4>
                    <small style="font-size: 11px;"><b>{{ $t('bases.indumentaria_incluida') }}</b></small><br/>
                    <div class="has-options mt-4">
                        <b-table style="width: 69%; margin: auto;" hover :items="indumentariasElegidas" :fields="fields" id="indumentarias-table">
                            <template #cell(precio)="{ item }">
                                <p v-if="item.incluida"><del>{{ item.precio | formatear_precio }}</del> ({{ '0' | formatear_precio }})</p>
                                <p v-else>{{ item.precio | formatear_precio }}</p>
                            </template>
                            <template #cell(talla)="{ item }">
                                <p>{{ item.talla.nombre }}</p>
                            </template>
                            <template #cell(cantidad)="{ item }">
                                <p>{{ item.unidades }}</p>
                            </template>
                            <template #cell(imagen)="{ item }">
                                <img :src="item.imagen" style="width: 75px;"/>
                            </template>
                            <template #cell(eliminar)="{ item }">
                                <button class="border-0 bg-transparent p-2" type="button" @click="eliminarIndumentaria(item)" :disabled="!paso_activo"><h6><i class="text-danger fas fa-times-circle"></i></h6></button>
                            </template>
                        </b-table>
                        <div v-if="error_indumentaria_reservada && indumentariasElegidas.length == 0" class="alert alert-danger" role="alert">
                            {{ error_indumentaria_reservada }}
                        </div>
                    </div>
                    <hr/>
                    <b-row style="width: 69%; margin: auto;" v-if="indumentariasElegidas.length > 0">
                        <b-col md="12" lg="6">
                            <div class="form-group">
                                <label for="camiseta_nombre">{{ $t('bases.nombre_indumentarias') }}</label>
                                <input 
                                    id="camiseta_nombre" 
                                    type="text" 
                                    class="form-control" 
                                    v-model="base.camiseta_nombre"
                                    :placeholder="$t('bases.nombre_indumentarias')" 
                                    :disabled="!paso_activo"
                                />
                            </div>
                        </b-col>
                        <b-col md="12" lg="6">
                            <div class="form-group">
                                <label for="camiseta_numero">{{ $t('bases.numero_indumentarias') }}</label>
                                <input 
                                    id="camiseta_numero" 
                                    type="text" 
                                    class="form-control" 
                                    v-model="base.camiseta_numero"
                                    :placeholder="$t('bases.numero_indumentarias')" 
                                    :disabled="!paso_activo"
                                />
                            </div>
                        </b-col>
                    </b-row>
                    <hr width="69%"/>
                    <div style="padding-left: 15%;" class="mt-5 text-left">
                        <button @click="terminar" id="terminar-paso-5" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" :disabled="!paso_activo">
                            <span>{{ $t('formularios.continuar') }}</span>
                        </button>
                        <button @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button ml-2' : 'button effect-button ml-2'" id="volver-paso-1" :disabled="!paso_activo" >
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                    </div>
                </div>
            </section>
        </ValidationObserver>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {
        props: ["base", "paso_activo", "esMovil"],
        data() {
            return {
                select: false,
                indumentarias: null,
                indumentariasElegidas: [],
                error_indumentaria_reservada: null,
                fields: [
                    { key: "nombre", label: this.$t('bases.nombre_indumentaria'), class: 'text-center' },
                    { key: "precio", label: this.$t('bases.precio_indumentaria'), class: 'text-center' },
                    { key: "talla", label: this.$t('bases.talla_indumentaria'), class: 'text-center' },
                    { key: "cantidad", label: this.$t('bases.cantidad_indumentaria'), class: 'text-center' },
                    { key: 'imagen', label: this.$t('bases.imagen_indumentaria'), class: 'text-center' },
                    { key: 'eliminar', label: "", class: 'text-center' }
                ],
                loading: false
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        methods: {
            getIndumentarias() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.base.categoria_base.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.categorias.bases.indumentarias'), params).then(res => {
                    this.indumentarias = res.data.indumentarias;
                    this.loading = false;
                })
            },
            reservarIndumentaria() {
                this.loading = true;

                let params = {
                    indumentarias: this.indumentariasElegidas,
                    categoria_id: this.base.categoria_base.id,
                    base: this.base,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.bloquear-indumentarias'), params).then(res => {
                    this.loading = false;
                    this.base.categoria_base.session_id = res.data.session_id;
                    this.$emit("terminado", this.indumentariasElegidas);
                }).catch(error => {
                    this.error_indumentaria_reservada = error.response.data.message;
                    this.getIndumentarias();
                    this.indumentariasElegidas = [];
                    this.loading = false;
                });
            },
            addIndumentaria(indumentaria) {
                //Primero comprobamos si hay alguna indumentaria elegida con esa talla y la borramos
                if (this.indumentariasElegidas && this.indumentariasElegidas.length > 0) {
                    while(this.indumentariasElegidas.filter(ind => ind.id === indumentaria.id && ind.talla.id === indumentaria.tallaSelect.id).length > 0) {
                        this.indumentariasElegidas.splice(this.indumentariasElegidas.findIndex(el => el.id === indumentaria.id && el.talla.id === indumentaria.tallaSelect.id), 1);
                    }
                }

                //Despues comprobamos si la indumentaria que a seleccionado va incluida en el precio y si no hay ninguna ya incluida
                if(indumentaria.incluida && this.indumentariasElegidas.filter(ind => ind.id === indumentaria.id && ind.incluida === true).length == 0) {
                    const indumentaria_incluida = {
                        id: indumentaria.id,
                        talla: {
                            id: indumentaria.tallaSelect.id,
                            nombre: indumentaria.tallaSelect.nombre,
                            stockDisponible: indumentaria.tallaSelect.stockDisponible,
                            stock_total: indumentaria.tallaSelect.stock_total
                        },
                        unidades: indumentaria.stockSelect < indumentaria.cantidad_incluida ? indumentaria.stockSelect : indumentaria.cantidad_incluida,
                        precio: indumentaria.precio,
                        precio_total: 0,
                        incluida: true,
                        nombre: indumentaria.nombre,
                        imagen: indumentaria.imagen
                    }

                    //Si va incluida añadimos una unidad incluida
                    this.indumentariasElegidas.push(indumentaria_incluida);

                    if(indumentaria.stockSelect - indumentaria.cantidad_incluida > 0) {
                        const resto_indumentarias = {
                            id: indumentaria.id,
                            talla: {
                                id: indumentaria.tallaSelect.id,
                                nombre: indumentaria.tallaSelect.nombre,
                                stockDisponible: indumentaria.tallaSelect.stockDisponible,
                                stock_total: indumentaria.tallaSelect.stock_total
                            },
                            unidades: indumentaria.stockSelect - indumentaria.cantidad_incluida,
                            precio: indumentaria.precio,
                            precio_total: indumentaria.precio * indumentaria.stockSelect - (indumentaria.precio * indumentaria.cantidad_incluida),
                            incluida: false,
                            nombre: indumentaria.nombre,
                            imagen: indumentaria.imagen
                        }

                        //Despues añadimos el resto restando al stock la incluida
                        this.indumentariasElegidas.push(resto_indumentarias);
                    }
                } else {
                    //Si la indumentaria que a seleccionado no va incluida en el precio se añaden todas
                    const resto_indumentarias = {
                        id: indumentaria.id,
                        talla: {
                            id: indumentaria.tallaSelect.id,
                            nombre: indumentaria.tallaSelect.nombre,
                            stockDisponible: indumentaria.tallaSelect.stockDisponible,
                            stock_total: indumentaria.tallaSelect.stock_total
                        },
                        unidades: indumentaria.stockSelect,
                        precio: indumentaria.precio,
                        precio_total: indumentaria.precio * indumentaria.stockSelect,
                        incluida: false,
                        nombre: indumentaria.nombre,
                        imagen: indumentaria.imagen
                    }

                    this.indumentariasElegidas.push(resto_indumentarias);
                }
                indumentaria.tallaSelect = null;
                indumentaria.stockSelect = null;
            },
            eliminarIndumentaria(indumentaria) {
                this.indumentariasElegidas.splice(this.indumentariasElegidas.findIndex(el => el.unidades === indumentaria.unidades && el.talla.id === indumentaria.talla.id), 1);
            },
            terminar() {
                this.reservarIndumentaria();
            },
            volver() {
                this.$emit('volver');
            }
        },
        created() {
            this.getIndumentarias();
        },
        components: {
            ContentOrLoading
        },
    };
</script>

<style scoped>
    .overlay {
        position: relative;
    }

    .overlay_0 {
        position: absolute;
        top: 80px;
        left: 20px;
        color: red;
        transform: rotate(330deg);
    }
</style>